module.exports = __webpack_public_path__ + "static/media/ic_menu_dots_v.113cdfbe.svg";